import { lazy } from 'react'

import type { RouteObject } from 'react-router'

const PropostaChilePage = lazy(() =>
  import('@/features/proposta/chile/pages/criar-proposta').then((module) => ({
    default: module.PropostaChilePage,
  })),
)

const PropostaAtivaChilePage = lazy(() =>
  import('@/features/proposta/chile/pages/proposta-ativa').then((module) => ({
    default: module.PropostaAtivaChilePage,
  })),
)

const PropostaDocumentosChilePage = lazy(() =>
  import('@/features/proposta/chile/pages/documentos').then((module) => ({
    default: module.PropostaDocumentosChilePage,
  })),
)

const EnvioDocumentosChilePage = lazy(() =>
  import('@/features/proposta/chile/pages/envio-documentos').then((module) => ({
    default: module.EnvioDocumentosChilePage,
  })),
)

export const chilePropostaRoutes: RouteObject[] = [
  {
    path: 'es-CL/proposta',
    children: [
      {
        index: true,
        element: <PropostaChilePage />,
      },
      {
        path: ':numero',
        element: <PropostaAtivaChilePage />,
      },
      {
        path: ':numero/documentos',
        element: <PropostaDocumentosChilePage />,
      },
      {
        path: ':numero/documentos/envio/:pessoaId',
        element: <EnvioDocumentosChilePage />,
      },
    ],
  },
]
